// Standalone Quality Signals report viewer — opened in its own tab from the
// reports feed. Fetches the complete (house-stylesheet-wrapped) HTML document
// with the bearer token and renders it in a sandboxed iframe so the agent's
// markup is isolated (no script execution, no parent access).

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { signalsReportsApi } from '../services/signalsReports';
import styles from './SignalsReportViewPage.module.css';

export function SignalsReportViewPage() {
  const { id } = useParams<{ id: string }>();
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) {
      setError('No report id.');
      return;
    }
    let active = true;
    signalsReportsApi
      .fetchHtml(id)
      .then((doc) => {
        if (active) setHtml(doc);
      })
      .catch(() => {
        if (active) setError('Report not found, or you are not authorized to view it.');
      });
    return () => {
      active = false;
    };
  }, [id]);

  if (error) {
    return <div className={styles.center}>{error}</div>;
  }
  if (html === null) {
    return <div className={styles.center}>Loading report…</div>;
  }

  return (
    <div className={styles.wrap}>
      <iframe
        className={styles.frame}
        title="Quality Signals report"
        srcDoc={html}
        sandbox="allow-popups allow-popups-to-escape-sandbox"
      />
    </div>
  );
}
